"use strict";
/*
The type MustHavePropertiesOfType<T, U> is a TypeScript utility type that filters the properties of
a given type T based on whether their values are of a certain type U.
It ensures that the resulting type will only include properties whose values are of the specified type U.
*/
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=general.types.js.map